import { getCookie, setCookie } from '../helpers/cookies';

// set jQuery
const $ = window.jQuery;

const KnMarketSection = (function() {
  let property;

  function init() {

    // document ready
    $(document).ready(function(){

      // setup market
      setupMarket();

      // start listeners
      startListeners();

    });

  };

  function startListeners() {

    // admin menu market listener
    adminMenuListener();

    // selector listener
    selectorListener();
  }

  function adminMenuListener() {

    $(document).on('click', '#wp-admin-bar-kn-market-menu a', function() {

      let marketName = $(this).parent().attr('id').split('wp-admin-bar-kn-market-menu-')[1];

      setMarket(marketName);

    });
  }

  function setMarketOnEndpoint(marketName) {

    return $.ajax({
      method: "POST",
      data: {
        action : 'kn_set_selected_market',
        market : marketName
      },
      url: kn_variables.ajaxurl
    })

  }

  function selectorListener() {

    $('.select-market ul li a').click(function(e) {

      e.preventDefault();

      // get market param from A tag through the data-market attribute
      let market = $(this).attr('data-market');

      console.log('market'+market);

      setMarket(market);

    });

  }

  function setMarket(market) {

    // post to the API
    setMarketOnEndpoint(market);

    // set cookie
    setCookie('market', market);

    // set URL parameter ?market=america
    // insertParam('market', $(this).attr('data-market'));
    location.reload();
    return false;

  }

  // function setSelectorOnAdminMenu() {

  // }

  function createMarketCookie() {
    //Markets: 
    //  global
    //  america
    //  asia
    //  latam
    //Continents: 
    //  AF - Africa
    //  AN - Antarctica
    //  AS - Asia
    //  EU - Europe
    //  NA - North america
    //  OC - Oceania
    //  SA - South america
  
    var endpoint = 'https://pro.ip-api.com/json/?fields=status,message,continentCode&key=KsdsRxhgdVNzmI9';
    //console.log(endpoint);
  
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        var response = JSON.parse(this.responseText);
        if(response.status !== 'success') {
          console.log('query failed: ' + response.message);
          setCookie('market', 'global');
          return
        }
        switch(response.continentCode) {
          case "AF": 
          case "AN": 
          case "OC": 
          case "EU": 
            setCookie('market', 'global');
            break;
          case "NA": 
            setCookie('market', 'america');
            break;
          case "AS": 
            setCookie('market', 'asia');
            break;
          case "SA": 
            setCookie('market', 'latam');
            break;
          default: 
            setCookie('market', 'global');
            break;
        }
      }
    };
    xhr.open('GET', endpoint, true);
    xhr.send();
  }
  function setupMarket() {

    // read cookie and set class in the body for showing specific market styles. The styles are in /styles/market-section.
    if (getCookie('market')) {

      $('html').addClass(getCookie('market'));

    } else {
      //setCookie('market', 'global');
      createMarketCookie();
      $('html').addClass('global');
    }

  }


  return {
    init
  }
})();

KnMarketSection.init();


/*
function checkCookie(name) {
  var dc = document.cookie;
  var prefix = name + "=";
  var begin = dc.indexOf("; " + prefix);
  if (begin == -1) {
    begin = dc.indexOf(prefix);
    if (begin != 0) return null;
  }else{
    begin += 2;
    var end = document.cookie.indexOf(";", begin);
    if (end == -1) {
      end = dc.length;
    }
  }
  return decodeURI(dc.substring(begin + prefix.length, end));
} 

var marketCookie = checkCookie('market');

if (marketCookie == null) {
  createMarketCookie();
}*/